import { Router } from '@angular/router';
import { OktaConfig } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../../../../environments/environment';

export const oktaConfig: OktaConfig = {
  oktaAuth: new OktaAuth({
    issuer: environment.okta_issuer,
    clientId: environment.okta_client_id,
    redirectUri: window.location.origin + environment.okta_redirectPath,
    scopes: environment.okta_scope,
  }),
  onAuthRequired: (_, injector) => injector.get(Router).navigate(['/login']),
};
